/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // RTL fix for the theme's <grid-slider>: its goToSlide() calls
  // scrollTo({left: item.offsetLeft}), but RTL scrollers clamp positive
  // scrollLeft to 0, so the arrows never move. Something on this site also
  // stops click propagation at the window capture phase before it reaches
  // the document (which is why the theme's own arrow handler never runs),
  // so this listener must sit on window capture to see the clicks at all.
  window.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('grid-slider [data-button-arrow]');
    if (!button) return;

    var gridSlider = button.closest('grid-slider');
    var slider = gridSlider && gridSlider.querySelector('[data-grid-slider]');
    if (!slider || getComputedStyle(slider).direction !== 'rtl') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var item = slider.querySelector('[data-grid-item]');
    if (!item) return;

    var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
    var step = item.getBoundingClientRect().width + gap;
    var forward = button.hasAttribute('data-button-next');

    // Chrome RTL scrollers run from 0 (start, right) into negative values, so
    // moving forward means scrolling left. The theme's momentum code cancels
    // native smooth scrolling, so drive a short ease-out animation ourselves.
    var startPos = slider.scrollLeft;
    var minPos = -(slider.scrollWidth - slider.clientWidth);
    var targetPos = Math.max(minPos, Math.min(0, startPos + (forward ? -step : step)));
    var startTime = performance.now();
    var duration = 350;

    var animate = function(now) {
      var progress = Math.min(1, (now - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      slider.scrollLeft = startPos + (targetPos - startPos) * eased;
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);

    // rAF stalls in hidden/throttled tabs; make sure the slider still lands
    // on the latest requested position.
    slider.setAttribute('data-rtl-scroll-target', targetPos);
    setTimeout(function() {
      var latest = parseFloat(slider.getAttribute('data-rtl-scroll-target'));
      if (!isNaN(latest) && Math.abs(slider.scrollLeft - latest) > 1) {
        slider.scrollLeft = latest;
      }
    }, duration + 100);
  }, true);

  // Site-wide input quality layer: Israeli phone auto-formatting, proper
  // mobile keypads and date-field polish for every current and future form.
  function formatIsraeliPhone(digits) {
    /* Mobile numbers read 052-345-6789: three parts, so a wrong digit is easy to spot. */
    if (digits.slice(0, 2) === '05' || digits.slice(0, 2) === '07') {
      digits = digits.slice(0, 10);
      if (digits.length > 6) return digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6);
      return digits.length > 3 ? digits.slice(0, 3) + '-' + digits.slice(3) : digits;
    }
    if (digits.charAt(0) === '0' && digits.length > 2) {
      digits = digits.slice(0, 9);
      return digits.slice(0, 2) + '-' + digits.slice(2);
    }
    return digits;
  }

  function enhanceInput(input) {
    if (!input || input.dataset.mybabyEnhanced === 'true') return;

    if (input.matches('input[type="tel"]')) {
      if (!input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'tel');
      if (!input.hasAttribute('autocomplete')) input.setAttribute('autocomplete', 'tel');
      /* Room for +972 52 345 6789 as well; a local number is capped by the formatter. */
      if (!input.hasAttribute('maxlength')) input.setAttribute('maxlength', '17');
      input.classList.add('mybaby-ltr-field');
    } else if (input.matches('input[type="number"], input[inputmode="numeric"]')) {
      if (!input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'numeric');
      input.classList.add('mybaby-ltr-field');
    } else if (input.matches('input[type="date"]')) {
      input.classList.add('mybaby-ltr-field');
      input.classList.toggle('has-value', input.value !== '');
    } else if (input.matches('input[type="email"]')) {
      if (!input.hasAttribute('autocomplete')) input.setAttribute('autocomplete', 'email');
      if (!input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'email');
      input.classList.add('mybaby-ltr-field');
    }

    input.dataset.mybabyEnhanced = 'true';
  }

  function enhanceAllInputs(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope
      .querySelectorAll('input[type="tel"], input[type="number"], input[type="date"], input[type="email"], input[inputmode="numeric"]')
      .forEach(enhanceInput);
  }

  document.addEventListener('input', function(event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[type="tel"], input[inputmode="tel"]')) return;
    if (input.value.charAt(0) === '+') return;

    var atEnd = input.selectionEnd === input.value.length;
    var digits = input.value.replace(/\D/g, '');
    var formatted = formatIsraeliPhone(digits);

    if (formatted !== input.value && atEnd) {
      input.value = formatted;
    }
  });

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (input.matches && input.matches('input[type="date"]')) {
      input.classList.toggle('has-value', input.value !== '');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { enhanceAllInputs(document); });
  } else {
    enhanceAllInputs(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    enhanceAllInputs(event.target);
  });

  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1) enhanceAllInputs(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  var searchPopdownSelector = 'header-search-popdown';
  var focusReturnBoundAttribute = 'data-mybaby-focus-return';
  var predictiveSearchSelector = 'predictive-search';
  var predictiveSearchBoundAttribute = 'data-mybaby-result-ids';
  var idReferenceAttributes = ['aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns'];
  var flickitySelector = '.flickity-enabled, slider-component';

  function setControlLabel(control, label) {
    if (!control || !label) return;

    control.setAttribute('aria-label', label);

    var title = control.querySelector('svg title');
    if (title) title.textContent = label;
  }

  function localizeFlickityControls(scope) {
    if (!window.theme || !window.theme.strings) return;

    var roots = [];

    if (scope.nodeType === 1 && scope.matches(flickitySelector)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(Array.from(scope.querySelectorAll(flickitySelector)));
    }

    roots.forEach(function(root) {
      setControlLabel(
        root.querySelector('.flickity-prev-next-button.previous'),
        window.theme.strings.previousSlide
      );
      setControlLabel(
        root.querySelector('.flickity-prev-next-button.next'),
        window.theme.strings.nextSlide
      );

      root.querySelectorAll('.flickity-page-dot').forEach(function(dot, index) {
        var label = window.theme.strings.viewSlide.replace('[index]', index + 1);

        dot.textContent = label;
        dot.setAttribute('aria-label', label);
      });
    });
  }

  function scopePredictiveResultIds(resultsContainer) {
    var idMap = {};

    resultsContainer.querySelectorAll('[id]').forEach(function(element) {
      var originalId = element.getAttribute('id');
      if (originalId.indexOf(resultsContainer.id + '--') === 0) return;

      var scopedId = resultsContainer.id + '--' + originalId;

      idMap[originalId] = scopedId;
      element.setAttribute('id', scopedId);
    });

    resultsContainer.querySelectorAll(idReferenceAttributes.map(function(attribute) {
      return '[' + attribute + ']';
    }).join(',')).forEach(function(element) {
      idReferenceAttributes.forEach(function(attribute) {
        var value = element.getAttribute(attribute);
        if (!value) return;

        var updatedValue = value.split(/\s+/).map(function(id) {
          return idMap[id] || id;
        }).join(' ');

        element.setAttribute(attribute, updatedValue);
      });
    });
  }

  function bindPredictiveResultIds(scope) {
    scope.querySelectorAll(predictiveSearchSelector).forEach(function(component) {
      if (component.hasAttribute(predictiveSearchBoundAttribute)) return;

      var resultsContainer = component.querySelector('[data-predictive-search-results]');
      if (!resultsContainer || !resultsContainer.id) return;

      component.setAttribute(predictiveSearchBoundAttribute, 'true');
      scopePredictiveResultIds(resultsContainer);

      new MutationObserver(function() {
        scopePredictiveResultIds(resultsContainer);
      }).observe(resultsContainer, {childList: true, subtree: true});
    });
  }

  function bindSearchFocusReturn(scope) {
    scope.querySelectorAll(searchPopdownSelector).forEach(function(component) {
      if (component.hasAttribute(focusReturnBoundAttribute)) return;

      var details = component.querySelector('details');
      var trigger = component.querySelector('summary');
      var panel = component.querySelector('[data-popdown]');
      var closeButton = component.querySelector('[data-popdown-close]');

      if (!details || !trigger || !panel || !closeButton) return;

      component.setAttribute(focusReturnBoundAttribute, 'true');

      function returnFocusAfterClose() {
        var fallbackTimeout;

        function focusTrigger() {
          if (!component.classList.contains('is-open')) {
            details.removeAttribute('open');

            if (window.theme && window.theme.a11y) {
              window.theme.a11y.removeTrapFocus();
            }
          }

          window.requestAnimationFrame(function() {
            trigger.focus();
          });
        }

        function onTransitionEnd(event) {
          if (event.target !== panel || event.propertyName !== 'opacity') return;

          panel.removeEventListener('transitionend', onTransitionEnd);
          window.clearTimeout(fallbackTimeout);
          focusTrigger();
        }

        panel.addEventListener('transitionend', onTransitionEnd);
        fallbackTimeout = window.setTimeout(function() {
          panel.removeEventListener('transitionend', onTransitionEnd);
          focusTrigger();
        }, 900);
      }

      closeButton.addEventListener('click', returnFocusAfterClose);
      details.addEventListener('keyup', function(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          returnFocusAfterClose();
        }
      });
    });
  }

  function initializeSearchFocusReturn() {
    bindSearchFocusReturn(document);
    bindPredictiveResultIds(document);
    localizeFlickityControls(document);

    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) localizeFlickityControls(node);
        });
      });
    }).observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchFocusReturn, {once: true});
  } else {
    initializeSearchFocusReturn();
  }

  document.addEventListener('shopify:section:load', function(event) {
    bindSearchFocusReturn(event.target);
    bindPredictiveResultIds(event.target);
    localizeFlickityControls(event.target);
  });

  document.addEventListener('theme:slider:loaded', function(event) {
    localizeFlickityControls(event.target);
  });

  /* A sent form comes back from Shopify on "?contact_posted=true#<form id>".
     That address stayed in the browser, so every refresh showed the "sent"
     state again and the form never came back. Once the page has loaded (every
     script that reads the marker has read it by then) it is taken out of the
     address: the thank-you stays on screen, and a refresh gives a fresh form.
     Covers every contact form in the theme (events, birthdays, MY FUN,
     classes, order cancellation, notify me). */
  function forgetSentMarker() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('contact_posted') !== 'true') return;
      url.searchParams.delete('contact_posted');
      var query = url.searchParams.toString();
      window.history.replaceState(window.history.state, '', url.pathname + (query ? '?' + query : ''));
    } catch (error) {
      /* an old browser keeps the old behaviour */
    }
  }

  if (document.readyState === 'complete') {
    window.setTimeout(forgetSentMarker, 0);
  } else {
    window.addEventListener('load', function() {
      window.setTimeout(forgetSentMarker, 0);
    }, {once: true});
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
